
// SVG Icon: checkbox-on
export default { id: "terriajs-checkbox-on" };
export const id = "terriajs-checkbox-on";
export const name = "checkbox-on";
